var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tip-controller',{staticClass:"stream-chat__tip-controller mt-2 pa-4",attrs:{"transparent":"","thread-id":_vm.threadId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var enableTip = ref.enable;
var openerIcon = ref.openerIcon;
var activator = ref.activator;
return [_c('div',{staticClass:"stream-chat__input-wrapper "},[_c('send-message-controller',{staticClass:"stream-chat__input",attrs:{"thread-ids":[_vm.threadId]},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var sending = ref.sending;
var sendMessage = ref.sendMessage;
return [_c('base-send-message',{attrs:{"transparent":"","keep-focus":"","append-icon":enableTip && _vm.canTip ? openerIcon : 'sci-send',"sending":sending,"placeholder":_vm.$t('Message')},on:{"click:appendIcon":function($event){enableTip && _vm.canTip && activator()},"send":function (v, cb) { return sendMessage(v, function () {
              _vm.value = '';
              cb();
            }); },"keyup":function (v) { return (_vm.value = v); }}})]}}],null,true)})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }